import * as types from './mutation-types'

export default {
    [types.PENDING_CALL_OPENED](state) {
        state.pendingCalls++
    },
    [types.PENDING_CALL_CLOSED](state) {
        if (state.pendingCalls > 0) {
            state.pendingCalls--
        }
    }
}
